import { IBaseModel, BaseModel } from '../base.model';

export interface IRight extends IBaseModel {
  id?: number;
  name?: string;
  description?: string;
  route?: string;
  access?: string;
  method?: string;
  permission?: any;
  createdAt?: string;
  updatedAt?: string;

  isValidRight(): boolean;
}
export class RightDto extends BaseModel implements IRight {

  static methodValues: string[] = ['get', 'create', 'delete', 'update']
  static accessValues: string[] = ['self', 'agency']

  id?: number;
  name?: string;
  description?: string;
  route?: string;
  access?: string;
  method?: string;
  permission?: any;
  createdAt?: string;
  updatedAt?: string;

  constructor(opt?: IRight) {
    super(opt);
  }

  isValidRight(): boolean {
    let res = true
    if (Object.keys(this).length < 5) return false
    else {
      res = Object.keys(this).every(key => {
        if(!this[key]) {
          return false
        }
        return true
      })
    }
    return res
  }
}



// WEBPACK FOOTER //
// ./src/models/right/right.model.ts